// extracted by mini-css-extract-plugin
module.exports = {"container":"FormHeading_container__2nr_o","icon":"FormHeading_icon__1TXQu","title":"FormHeading_title__UW5Zw","subTitle":"FormHeading_subTitle__19S8M"};